import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStudents } from '../../lib/useStudents'
import useRole from '../../hooks/useRole'

function isDueWithin30Days(date) {
  if (!date) return false
  const d = typeof date === 'string' ? new Date(date) : (date.toDate ? date.toDate() : new Date(date))
  if (Number.isNaN(d.getTime())) return false
  const now = new Date()
  const in30 = new Date()
  in30.setDate(now.getDate() + 30)
  return d >= now && d <= in30
}

export default function ReviewsDue() {
  const navigate = useNavigate()
  const { students, loading } = useStudents({ orderByLastName: true })
  const { isSENCO } = useRole()

  const due = useMemo(() => {
    const list = students
      .filter(s => isDueWithin30Days(s.reviewDueDate))
      .slice(0, 6)
      .map(s => ({
        id: s.id,
        name: s.fullName || s.name || 'Student',
        path: s.path || s.currentPath || 'NC',
        dueDate: s.reviewDueDate,
      }))
    return list
  }, [students])

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-md border border-gray-100">
      <div className="p-5">
        <h2 className="text-base font-semibold text-gray-800">
          {isSENCO ? 'Annual Reviews Due' : 'Reviews Due'}
        </h2>
        {loading ? (
          <div className="mt-4 space-y-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-14 w-full rounded-xl bg-gray-100 animate-pulse" />
            ))}
          </div>
        ) : due.length === 0 ? (
          <p className="mt-3 text-sm text-gray-500">No upcoming reviews in the next 30 days.</p>
        ) : (
          <div className="mt-4 space-y-2">
            {due.map((s) => (
              <div 
                key={s.id} 
                className="flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors group"
              >
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-gray-900">{s.name}</p>
                  <p className="truncate text-xs text-gray-500">
                    {s.path} • Due {new Date(s.dueDate).toLocaleDateString()}
                  </p>
                </div>
                <button
                  onClick={() => navigate(`/students/${s.id}/decision`)}
                  className="ml-3 inline-flex items-center rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-600 hover:bg-blue-100 transition-colors"
                >
                  Review
                </button>
              </div>
            ))}
          </div>
        )}
        {due.length > 0 && (
          <div className="mt-4">
            <button
              onClick={() => navigate('/student-organization')}
              className="flex w-full items-center justify-center rounded-xl bg-gray-100 px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-colors"
            >
              View all students
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

